import React, { useState, useEffect, useRef } from "react";
import styles from "./scss/rightsidebar.module.scss";
import ProfileDetails from "./profiledetails";
import MenuOptions from "./menuoptions";
import TaskListsRight from "./tasklist";
import EventListsRight from "./eventlist";
import SavedChatListsRight from "./savedchat";
import NotesListsRight from "./noteslist";
import LinksListsRight from "./linklist";
import FileDefaults from "./filedefault";
import NotesDefaults from "./notedefault";
import TaskDefaults from "./taskdefault";
import MemberLists from "./memberlists";
import groovyWalkAnimation from "../../../styles/images/chat blank state loading.json";
import { useSelector } from "react-redux";
import { chats, contactwindowDetails, initialStateModel, LoginState, rightSidePanelDetails } from "../../../models/model";
import { chatwindowDetails } from "../../../models/model";
import store from "../../../context/store/store";
import { ChatService } from "../../../base/chatService";
import { Cookie } from "../../../base/utils";
import FilesListsRight from "./fileList";
import { Types } from "../../../context/action/action";
import { SocketChatService } from "../../../base/socketChatService";
import Lottie from "lottie-react";
import NotFound from "../../../styles/images/empty_states/notes_empty_state.svg";
import NoContent from "../../../shared/widgets/noContent";
import EventDefaults from "./eventdefault";
import { URButton } from "../../../shared/widgets/button";
import { closePrfWindow } from "../../../base/callService/store_mining";
import { generateChatID, userInfo } from "../../../base/socketChatService/utils";
import { Modal } from "antd";
import { URCheckBox } from "../../../shared/widgets/checkbox";
import blockSvg from "../../../styles/images/block.svg";
type RightSidebarSte = {
  mode: string;
  savedListData: any;
  linkListData: any;
  offset: number;
  limit: number;
  selectedId: any;
  fileList: any;
  allFilesList: any;
  activeTab: string;
  eventsList: any;
  taskList: any;
  notesList: any;
  isArchiveModel: boolean;
  archiveChat: any;
  clearSaved: boolean;
}

type uploadFiles = {
  handleToggle: any;
  teamMemberNames: any;
  openLeaveModal: any;
  deleteTeam: any;
  statusMember: any;
  deleteAction: any
}
type popoverState = {
  isArchive: boolean;
  isDelete: boolean;
  archiveChat: any;
  deleteData: any;
  deleteChat: any;
  isDeactivate:boolean;
  deactivateData:any;
}
export default function RightSidebar({ handleToggle, teamMemberNames, openLeaveModal, deleteTeam, statusMember, deleteAction }: uploadFiles) {

  const rightSideLink: rightSidePanelDetails = useSelector((state: initialStateModel) =>
    state.chatRightSidePanelReducer);
  let { fileListDetails, isfile } = rightSideLink;
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  const chatDetails: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  const socketChat = useRef<any>(null);
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const socketRecentStateReducer = useSelector((state: initialStateModel) => state.chatSocketRecentReducerState);
  const cDetails: contactwindowDetails = useSelector((state: initialStateModel) => state.contactWindowReducer);

  let { isNoteUpdate, isTaskUpdate, isEventUpdate } = cDetails;
  const recentChat: any = socketRecentStateReducer.recentChatList;
  let { userdetails } = loginDetails;
  const recentDetails = recentChat[chatDetails?.chatWindowDetails?.sip_login_id ?
    chatDetails?.chatWindowDetails?.sip_login_id : "con" + chatDetails?.chatWindowDetails.team_id];
  const [ArchiveModal, setArchiveModal] = useState<popoverState>({ isArchive: false, isDelete: false, archiveChat: {}, deleteData: {}, deleteChat: {},isDeactivate:false,deactivateData:{} })
  const [getItem, setItem] = useState<RightSidebarSte>({
    mode: 'all',
    activeTab: 'all',
    savedListData: [],
    linkListData: [],
    fileList: [],
    offset: 0,
    limit: 50,
    selectedId: '',
    allFilesList: [],
    eventsList: [],
    taskList: [],
    notesList: [], isArchiveModel: false, archiveChat: {}, clearSaved: false
  });
  useEffect(() => {
    const userInfo: any = Cookie.get();
    const userInfosess: any = sessionStorage.getItem("userinfo");
    if (userInfosess) {
      const cookieData = JSON.parse(userInfosess);
      socketChat.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
    }
  }, []);

  const updateTaskFalse = () => {
    store.dispatch({
      type: Types.CONTACT_TASK_UPDATE,
      payload: {
        isTaskUpdate: false
      }
    });

  };
  useEffect(() => {
    rightSideToggle('all');
    if (isTaskUpdate) {
      updateTaskFalse();
    }
  }, [isNoteUpdate, isTaskUpdate, isEventUpdate, chatDetails]);

  let enableTeamDetails = chatDetails?.chatWindowDetails?.team_id_prefix ||
    chatDetails?.chatWindowDetails?.team_id;
  const moreToggle = (mode: string) => {
    setItem({ ...getItem, activeTab: mode });

  };
  const rightSideToggle = async (mode: string) => {
    setItem({ ...getItem, mode: mode });
    if (mode === 'all') {
      let id = chatDetails.chatWindowDetails.chatId ? chatDetails.chatWindowDetails.chatId : chatDetails.chatWindowDetails.team_id;
      let filelist = {
        chatId: id,
        offset: 25,
        orderType: 1,
        id: ""
      }
      socketChat?.current?.fileListData(filelist);
      if (!rightSideLink.isSavedList) {
        let savedListInput = {
          chatId: id, offset: 25, orderType: 0, id: ""
        };

        socketChat?.current?.savedChatlistSingleUser(savedListInput);
      }
      Promise.all([ChatService.taskList(mode), ChatService.notesList(mode), ChatService.eventList(mode)])
        .then((response: Array<any>) => {
          let stateDetails = { ...getItem };
          stateDetails.mode = mode;

          setItem({
            ...getItem, mode: stateDetails.mode,
            taskList: response[0]?.result ? response[0]?.result : [],
            eventsList: response[2]?.result ? response[2]?.result : [],
            notesList: response[1]?.result ? response[1]?.result : []


          });
          store.dispatch({
            type: Types.GET_NOTES_LIST,
            payload: {
              isNotes: true,
              isNotesLoader: false,
              notesListDetails: response[1]?.result,
              notesDefaultCount: response[1]?.total_count
            }
          });
          store.dispatch({
            type: Types.GET_TASK_LIST,
            payload: {
              isTask: true,
              taskLoader: false,
              taskListDetails: response[0]?.result,
              taskDefaultCount: response[0]?.total_count
            }
          });
          store.dispatch({
            type: Types.GET_EVENT_LIST,
            payload: {
              isEvent: true,
              eventLoader: false,
              eventListDetails: response[2]?.result
            }
          });


        });

    }

  };

  const favContacts = (contactDetails: any) => {

    let chatId: any = contactDetails.sip_login_id ?
    generateChatID(userInfo().fromID, contactDetails?.sip_login_id.toString()) : contactDetails?.team_id.toString();
    let teamMemberFavourite = contactDetails?.team_members_favourite ? contactDetails?.team_members_favourite.split(",").map((ele: any) => ele.trim()): [];
    let chatDetails = { 
      chatId : chatId,
      settingsKey : "isFavourite",
      toSipId:contactDetails?.sip_login_id ? contactDetails?.sip_login_id?.toString():contactDetails?.team_id?.toString(),
      type: contactDetails?.sip_login_id ? 1:2,
      status : (contactDetails?.is_favourite || (Array.isArray(teamMemberFavourite) && teamMemberFavourite.length>0 &&
      teamMemberFavourite.indexOf(userdetails.sip_login_id)>-1))  ? 0:1,
      phoneNumber : contactDetails?.ext ?  contactDetails?.ext :""};
      const timer = setTimeout(()=>{
        socketChat.current.updateRecentChatSettings(chatDetails);
        socketChat.current.toastUndo("","")},3000);
      if((!contactDetails?.is_favourite && contactDetails?.sip_login_id) || ((Array.isArray(teamMemberFavourite) &&
      teamMemberFavourite.indexOf(userdetails.sip_login_id)===-1) && contactDetails?.team_id)){
        socketChat.current.toastUndo("Added to favourites",timer, 'favourite');
      } else {
        socketChat.current.toastUndo("Removed from favourites",timer, 'unfavourite');
      }

  }

  const openArchiveModal = () => {
    setItem({ ...getItem, isArchiveModel: true });
  }
  const cancelArchive = () => {
    setItem({ ...getItem, isArchiveModel: false });
  }
  const archiveAction = (key: any) => {
    let chatD = {
      chatId: chatDetails?.chatWindowDetails?.sip_login_id ? generateChatID(userInfo().fromID,
        chatDetails?.chatWindowDetails?.sip_login_id.toString()) : chatDetails?.chatWindowDetails?.team_id,
      settingsKey: "isArchive",
      status: key === "archive" ? 1 : 0
    }
    socketChat.current.updateRecentChatSettings(chatD);
    setItem({ ...getItem, isArchiveModel: false });
  };
  const clearChat = (contact: any) => {
    let { contactReducer } = allReducer;
    let workContact = contactReducer?.workContactsnew;
    let teamContact = contactReducer?.teamContacsnew;
    let toContact = contact?.type === 1 ? workContact[contact?.to] : teamContact["con" + contact?.chatId];
    console.log("To Contact ---->", toContact);
    setArchiveModal({ ...ArchiveModal, isDelete: true, deleteData: toContact, deleteChat: contact })
  }
  const handleCancel = () => {
    setArchiveModal({ ...ArchiveModal, isDelete: false, deleteData: {}, deleteChat: {} })
  }
  const clearOnchange = (e: any) => {
    setItem({ ...getItem, clearSaved: e.target.checked });
  }
  const deleteClearAction = () => {
    let chatDetails = {
      chatId: ArchiveModal?.deleteChat?.chatId,
      savedChatsatus: getItem?.clearSaved === true ? 0 : 1
    }
    socketChat.current.clearChatMessage(chatDetails);
    setArchiveModal({ ...ArchiveModal, isDelete: false, deleteData: {}, deleteChat: {} })

  };
  const deactivateAction = ()=>{
    let is_blocked:number = chatDetails?.chatWindowDetails?.is_blocked === 1?1:0;
    ChatService.getDeactivateContact(ArchiveModal?.deactivateData,is_blocked);
   
    setArchiveModal({ ...ArchiveModal, isDeactivate: false,deactivateData:{}});
  }
  const handleDeactiveCancel = ()=>{
    setArchiveModal({ ...ArchiveModal, isDeactivate: false,deactivateData:{}});
  }
  const deactivateContact = ()=>{
    if(chatDetails?.chatWindowDetails?.is_blocked === 1){
      let is_blocked:number = chatDetails?.chatWindowDetails?.is_blocked === 1?1:0;
      ChatService.getDeactivateContact(chatDetails?.chatWindowDetails,is_blocked);
     setArchiveModal({ ...ArchiveModal, isDeactivate: false,deactivateData:{}});
   
    } else {
      setArchiveModal({ ...ArchiveModal, isDeactivate: true,deactivateData:chatDetails?.chatWindowDetails});
    }
  }
const EmailTrigger = () =>{
    try {
      var formattedBody = "";
      const participants: any =chatDetails.chatWindowDetails?.email_id;
      var emailto = encodeURI(participants);
      var subject = '';
      const generateURL= "mailto:" + emailto + "?subject="+subject + "&body=" +encodeURIComponent(formattedBody);
      window.open(generateURL, 'new');
    }
    catch (error) {
      console.log("error", error);
    }

}

  let teamMemberOnly = chatDetails?.chatWindowDetails?.team_members ? chatDetails?.chatWindowDetails?.team_members.split(",").map((ele: any) => ele.trim()) : [];
  let teamMemberFavourite = chatDetails?.chatWindowDetails?.team_members_favourite ? chatDetails?.chatWindowDetails?.team_members_favourite.split(",").map((ele: any) => ele.trim()) : [];
  return (
    <>
      <div className={styles.rightsidebar}>
      
        <div className={styles.topsection}>
          {window.location.pathname === ('/calls') && <span className="icon_close rightsideclose" onClick={closePrfWindow}></span>}
          <MenuOptions activeTab={getItem.activeTab} rightSideToggle={moreToggle}></MenuOptions>

        </div>
        <div className={`scroller ${styles.rightsideScroller}`}>
          {
            <div className={`${styles.bottomsection}`}>
              {getItem.mode === 'all' && getItem.activeTab === "all" && (chatReducer.isKey === "all" || chatReducer.isKey === "") ?
                <>
                  <ProfileDetails teamMemberNames={teamMemberNames}></ProfileDetails>
                  <div className={`${styles.membersSection} ${"scroller"}`}>{enableTeamDetails && chatDetails?.chatWindowDetails?.team_members && <MemberLists></MemberLists>}
                    {/* {((isfile===false && fileListDetails.length === 0) ||
               ( rightSideLink.isTask===false && getItem.taskList.length === 0)
               ||
                ( rightSideLink.isNotes===false && getItem.notesList.length === 0))?
                  <Lottie className="svgLoading"
                    animationData={groovyWalkAnimation} />:
                  isfile && fileListDetails.length>0 && <FileDefaults></FileDefaults>}
                { rightSideLink.isNotes &&getItem.notesList.length>0&&
                  <NotesDefaults></NotesDefaults>}
                {rightSideLink.isTask && getItem.taskList.length>0&&<TaskDefaults></TaskDefaults>}
                {rightSideLink.isEvent && getItem.eventsList.length>0&&<EventDefaults></EventDefaults>}             */}
                  </div>
                  {/* { isfile && rightSideLink.isTask && rightSideLink.isNotes
                && fileListDetails.length === 0 && getItem.taskList.length === 0
                && getItem.notesList.length === 0
                && <NoContent image={NotFound}
                  title={"No Files Tasks and Notes"}
                />} */}
                  <>
                    {/* <div className={styles.rightsidebottomexitbutton} > */}

                    {/* </div> */}
                  </>
                </>
                :
                (getItem.activeTab === 'task' || chatReducer.isKey === "tasklist") ?
                  <TaskListsRight taskLists={getItem.taskList} ></TaskListsRight>
                  :
                  (getItem.activeTab === 'notes' || chatReducer.isKey === 'notelist') ?
                    <NotesListsRight notesLists={getItem.notesList}></NotesListsRight> :

                    (getItem.activeTab === 'event' || chatReducer.isKey === "eventlist") ?
                      <EventListsRight eventsDetails={getItem.eventsList} ></EventListsRight> :

                      (getItem.activeTab === 'files') ?
                        <FilesListsRight fileList={fileListDetails} ></FilesListsRight> :

                        (getItem.activeTab === 'saved chat') ?
                          <SavedChatListsRight chatSaved={rightSideLink.savedListDetails} ></SavedChatListsRight> :

                          (getItem.activeTab === 'links') &&
                          <LinksListsRight></LinksListsRight>

              }
            </div>
          }
          {(chatReducer.isKey === "" || chatReducer.isKey === "all")  && chatDetails.chatWindowDetails?.caller_id && <div className={styles.userProfileDetails}>
            <ul className={styles.userDetailsList}>
              <li><span className={styles.smallText}>Department</span><span className={styles.blockText}>{chatDetails.chatWindowDetails?.department}</span></li>
              <li><span className={styles.smallText}>Extension</span><span className={styles.blockText}>{chatDetails.chatWindowDetails?.ext}</span></li>
              <li><span className={styles.smallText}>Company Number</span><span className={styles.blockText}>01212190524</span></li>
              <li><span className={styles.smallText}>International Number</span><span className={styles.blockText}>+4368860755414</span></li>
              <li><span className={styles.smallText}>Email</span><span className={styles.blockText} onClick={EmailTrigger}><a>{chatDetails.chatWindowDetails?.email_id}</a></span></li>
            </ul>
          </div>}
         {(chatReducer.isKey === "" || chatReducer.isKey === "all")  && <div className={styles.fixbottom}>
            <ul className={styles.rightSideBottomList}>
              {/* <li onClick={() => favContacts(chatDetails?.chatWindowDetails)}>
              {chatDetails?.chatWindowDetails?.team_id && teamMemberOnly.includes(userdetails.sip_login_id) ? 
              <>
              {(teamMemberFavourite.indexOf(userdetails.sip_login_id) > -1) ? <><span className="icon__favFilled"></span>Remove Favourite</>:<><span className="icon__fav"></span>Favourite</>}
               
               </> :  <>
               <span className={chatDetails?.chatWindowDetails?.is_favourite === 0 ? "icon__fav" : "icon__favFilled"}></span>{chatDetails?.chatWindowDetails?.is_favourite === 0 ? "Favourite " : "Remove Favourite"}
                </>
}
               </li> */}
              {/* <li onClick={openArchiveModal}>
                {recentDetails?.settings?.isArchive?.["s" + userdetails?.sip_login_id] ?
                  <><span className="icon_unarchivefull"></span> UnArchive </> : <><span className="icon__archiveFilled"></span> Archive</>}</li> */}
              <li className={styles.clearChat} onClick={() => clearChat(recentDetails)}><span className="icon__clear"></span> Clear Chat</li>
             {userdetails?.ext?.toString() === '200' && chatDetails.chatWindowDetails?.sip_login_id &&  <li className={styles.clearChat} onClick={() => deactivateContact()}>
             <img src={blockSvg} alt=""/>
            {chatDetails.chatWindowDetails?.is_blocked === 1 ? "Activate Contact":"Deactivate Contact"} </li>}
            </ul>
            {/* <DownloadRight></DownloadRight> */}
          </div>}
          {statusMember && chatDetails.chatWindowDetails?.team_id && (chatReducer.isKey === "" || chatReducer.isKey === "all")  &&
            <div className={styles.exitButton} onClick={openLeaveModal}>
              <URButton className='urButton buttonExit buttonSm ' name='Exit from team' />
            </div>}
          {!statusMember && chatDetails.chatWindowDetails?.team_id &&
            recentChat?.["con" + chatDetails?.chatWindowDetails?.team_id]?.settings?.isDeleted?.["s" + userdetails?.sip_login_id] === 0
            && <div className={styles.delButton} onClick={deleteTeam}>
              <URButton className='urButton buttonExit buttonSm' name='Delete Team' />
            </div>}
        </div>
      </div>
      {/* {getItem.isArchiveModel && <Modal visible={getItem.isArchiveModel} className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span className={`icon_close ${styles.cursorTop}`} onClick={cancelArchive} />
        <h2>Archive Chat?</h2>
        <p>When you archive a chat, you will no longer receive any notifications from this chat,
          and the chat will be removed from your Recent Chat(s) list. Click button Confirm to proceed.</p>
        <div className={styles.footersection}>
          <URButton className="urButton buttonWhite buttonMd mr8" onClick={cancelArchive} name="Cancel"></URButton>
          <URButton className="urButton buttonRed buttonMd" onClick={() => archiveAction("archive")} name="Confirm"></URButton>
        </div>
      </Modal>} */}

      {ArchiveModal.isDelete && <Modal visible={ArchiveModal.isDelete}
        className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
        <span onClick={handleCancel} className={`icon_close ${styles.cursorTop}`} />
        <h2>Clear Chat?</h2>
        <p>Are you sure you want to clear this chat? You cannot retrieve the unsaved messages.</p>
        <p className={styles.checkArea}>
            <input type="checkbox" name="" onChange={(e: any) => clearOnchange(e)} />
          {/* <URCheckBox onChange={(e: any) => clearOnchange(e)} /> */}
          Keep saved messages</p>
        <div className={styles.footersection}>
          <URButton className="urButton buttonWhite buttonMd mr8" onClick={handleCancel} name="Cancel"></URButton>
          <URButton className="urButton buttonRed buttonMd" onClick={deleteClearAction} name="Clear Chat"></URButton>
        </div>
      </Modal>}
      {ArchiveModal.isDeactivate && <Modal visible={ArchiveModal.isDeactivate}
          className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
          <span onClick={handleDeactiveCancel} className={`icon_close ${styles.cursorTop}`} />
          <h2>Deactivate Contact</h2>
          <p>{chatDetails.chatWindowDetails?.caller_id} will able to contact you. Are you sure you want to deactivate this contact?</p>
          <div className={styles.footersection}>
            <URButton className="urButton buttonWhite buttonMd mr8" onClick={handleDeactiveCancel} name="Cancel"></URButton>
            <URButton className="urButton buttonRed buttonMd" onClick={deactivateAction} name= {"Deactivate"}></URButton>
          </div>
        </Modal>}
    </>
  );
};

